import { 
    BodyXLMedium,
    BodySmallRegular
} from '@/components/typography';
import { OutlineButton } from '@/components/buttons';

interface GenericCardProps {
    image: string;
    title: string;
    description?: string;
    buttonText?: string;
    onButtonClick?: () => void;
    className?: string;
    titleClassName?: string;
    imageClass?: string;
}

export const GenericCard = ({ 
    image, 
    title, 
    description, 
    buttonText, 
    onButtonClick,
    className = '',
    titleClassName = 'max-w-[130px]',
    imageClass = ''
}: GenericCardProps) => {
    return (
        <div className={`col-span-1 relative bg-gradient-to-br from-white/20 to-white/5 rounded-3xl shadow-sm backdrop-blur-xl border border-white/10 ${className}`}>
            <div className="relative rounded-3xl h-full">
                <div className="flex justify-center pt-0">
                    <img 
                        className={`w-20 h-20 -mt-8 lg:w-32 lg:h-32 ${imageClass}`}
                        src={image} 
                        alt={title}
                    />
                </div>
                
                {/* Content area */}
                <div className="px-0 lg:px-4 pb-6 pt-2 flex flex-col items-center gap-3">
                    <BodyXLMedium className={`text-center text-white ${titleClassName}`}>
                        {title}
                    </BodyXLMedium>
                    
                    {description && (
                        <BodySmallRegular className="text-center text-white/60">
                            {description}
                        </BodySmallRegular>
                    )}
                    
                    {buttonText && (
                        <OutlineButton onClick={onButtonClick} className="w-48 p-2 lg:px-2.5 lg:py-4">{buttonText}</OutlineButton>
                    )}
                </div>
            </div>
        </div>
    );
};